import React from 'react'
import { Column } from 'primereact/column'
import ContributorNameDropdownEditor from './ContributorNameDropdownEditor'
import ContributorNameBodyTemplate from './ContributorNameBodyTemplate'
import { createColumnAttributes } from '../utils/createColumnAttributes'
import { getRowClassName } from '../utils/getRowClassName'

const ContributorNameColumn = ({ title, mapsToField, filter, sortable, editable, isFieldChanged, isFieldChangedOverride, validationErrors, contributorNames, originalData }) => {
    const { filterAttributes, sortAttributes, checkFieldChanged } = createColumnAttributes({
        filter,
        title,
        sortable,
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isFieldChanged,
        mapsToField,
        originalData
    })

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            body={(rowData) => (
                <span className={getRowClassName(checkFieldChanged, rowData)}>
                    <ContributorNameBodyTemplate rowData={rowData} field={mapsToField} />
                </span>
            )}
            editor={editable ? (options) => (
                <ContributorNameDropdownEditor
                    options={options}
                    rowData={options.rowData}
                    rowIndex={options.rowIndex}
                    contributorNames={contributorNames}
                    editorCallback={options.editorCallback}
                    validationErrors={validationErrors}
                />
            ) : null}
            {...filterAttributes}/>
    )
}

export default ContributorNameColumn
